import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  state: 0,
  username: undefined,
  myIds: "",
  enrollment: false,
  points: 0,
  isLogin: false,
  rebatesToken: null,
  rebatesTokenExpiry: null,
};

const slice = createSlice({
  name: "user",
  initialState,
  reducers: {
    SET_LOYALITY_POINTS: (state, action) => {
      return { ...state, points: action.payload.points };
    },
    INIT_USER: (state) => {
      return Object.assign({}, state, { state: 0 });
    },
    SET_USER: (state, action) => {
      const { username, myIds, enrollment } = action.payload;
      return Object.assign({}, state, {
        state: action.payload.state,
        username: username,
        myIds: myIds,
        enrollment: enrollment,
      });
    },
    CLEAR_USER: (state, action) => {
      localStorage.removeItem("pbyt");
      return initialState;
    },
    SET_USER_LOGIN_STATUS: (state) => {
      return { ...state, isLogin: true };
    },
    USER_DETAILS: (state, action) => {
      return { ...state, userDetails:action.payload };
    },
    SET_REBATES_TOKEN: (state, action) => {
      state.rebatesToken = action.payload.token;
      state.rebatesTokenExpiry = action.payload.expiry;
    },
    CLEAR_REBATES_TOKEN: (state) => {
      state.rebatesToken = null;
      state.rebatesTokenExpiry = null;
    },
  },
});

export const {
  SET_USER,
  INIT_USER,
  CLEAR_USER,
  SET_USER_LOGIN_STATUS,
  SET_LOYALITY_POINTS,
  USER_DETAILS,
  SET_REBATES_TOKEN,
  CLEAR_REBATES_TOKEN,
} = slice.actions;

export default slice.reducer;
